import React, { useEffect, useState } from "react";
import { api } from "@/lib/caesar";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, SectionLabel } from "@/components/common";
import { ShieldCheck } from "lucide-react";

export default function MemberPortal() {
  const { user } = useAuth();
  const [mission, setMission] = useState("");

  useEffect(() => {
    api.get("/mission").then(({ data }) => setMission(data?.text || "")).catch(() => {});
  }, []);

  return (
    <div className="space-y-8" data-testid="member-portal">
      <PageHeader testId="portal-header" title={`Welcome, ${user?.name || "Member"}`} subtitle="Private Member Portal — Authorized Access Only" />

      <div className="bg-surface border border-gold/30 rounded-xl p-5 flex items-start gap-3">
        <ShieldCheck size={20} className="text-gold shrink-0 mt-0.5" />
        <p className="text-sm text-[#A3A3A3]">You have secure member access. Only information approved for members is shown here.</p>
      </div>

      <div>
        <SectionLabel>Mission</SectionLabel>
        <div className="bg-surface border border-edge rounded-xl p-5" data-testid="portal-mission">
          {mission ? <p className="text-sm leading-relaxed whitespace-pre-wrap">{mission}</p>
            : <p className="text-sm text-[#A3A3A3]">No member updates published yet. Check back soon.</p>}
        </div>
      </div>
    </div>
  );
}
